import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from '../../services/translation.service';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {
    constructor(private route: ActivatedRoute, private translationService: TranslationService) { }

    /**
     * @param key  The key
     * @return translated value or key if does not exists
     */

    public transform(key: string): string {
        return this.translationService.translate(key);
    }
}
